import { CALENDAR_CLOUD_SETTINGS_BASE_URL } from '../constants';
import type CalendarCloudSetting from '../store/schema/CalendarCloudSetting';
import { CalendarCloudSettingType } from '../store/schema/CalendarCloudSettingType';
import { makePatchRequest } from 'owa-ows-gateway';
import {
    CalendarCloudSettingValueTypeString,
    CalendarCloudSettingScopeType,
} from '../store/schema/CalendarCloudSettingRequestEnums';

/**
 * Sets the updated calendar cloud settings
 * @param calendarCloudSettings - updates
 */
export default function setCalendarCloudSettingsService(
    calendarCloudSettings: CalendarCloudSetting[]
): Promise<any> | null {
    const requestBody = createRequestBody(calendarCloudSettings);
    if (!requestBody) {
        return null;
    }

    return makePatchRequest(
        CALENDAR_CLOUD_SETTINGS_BASE_URL + CalendarCloudSettingScopeType.Global,
        requestBody,
        undefined /* correlationId */,
        true /* returnFullResponse */
    );
}

/**
 * Creates the request body based one the updated settings
 * @param calendarCloudSettings
 */
function createRequestBody(calendarCloudSettings: CalendarCloudSetting[]) {
    const requestBody: CalendarCloudSetting[] = [];

    calendarCloudSettings.forEach(setting => {
        if (!setting.name || setting.value == null) {
            return;
        }

        switch (setting.name.toLowerCase()) {
            case CalendarCloudSettingType.ShouldEventsEndEarly.toLowerCase():
                requestBody.push({
                    name: CalendarCloudSettingType.ShouldEventsEndEarly,
                    value: setting.value,
                    type: CalendarCloudSettingValueTypeString.Bool,
                    scope: CalendarCloudSettingScopeType.Global,
                });
                break;
            case CalendarCloudSettingType.ShortenEventScope.toLowerCase():
                requestBody.push({
                    name: CalendarCloudSettingType.ShortenEventScope,
                    value: setting.value,
                    type: CalendarCloudSettingValueTypeString.String,
                    scope: CalendarCloudSettingScopeType.Global,
                });
                break;
            case CalendarCloudSettingType.EndShortEventsBy.toLowerCase():
                requestBody.push({
                    name: CalendarCloudSettingType.EndShortEventsBy,
                    value: setting.value,
                    type: CalendarCloudSettingValueTypeString.Int,
                    scope: CalendarCloudSettingScopeType.Global,
                });
                break;
            case CalendarCloudSettingType.EndLongEventsBy.toLowerCase():
                requestBody.push({
                    name: CalendarCloudSettingType.EndLongEventsBy,
                    value: setting.value,
                    type: CalendarCloudSettingValueTypeString.Int,
                    scope: CalendarCloudSettingScopeType.Global,
                });
                break;
            case CalendarCloudSettingType.EnableOnlineMeetingsByDefault.toLowerCase():
                requestBody.push({
                    name: CalendarCloudSettingType.EnableOnlineMeetingsByDefault,
                    value: setting.value,
                    type: CalendarCloudSettingValueTypeString.Bool,
                    scope: CalendarCloudSettingScopeType.Global,
                });
                break;
            case CalendarCloudSettingType.RoamingTimezones.toLowerCase():
                requestBody.push({
                    name: CalendarCloudSettingType.RoamingTimezones,
                    value: JSON.stringify(setting.value),
                    type: CalendarCloudSettingValueTypeString.Json,
                    scope: CalendarCloudSettingScopeType.Global,
                });
                break;
            case CalendarCloudSettingType.PrimaryTimezoneLabel.toLowerCase():
                requestBody.push({
                    name: CalendarCloudSettingType.PrimaryTimezoneLabel,
                    value: setting.value,
                    type: CalendarCloudSettingValueTypeString.String,
                    scope: CalendarCloudSettingScopeType.Global,
                });
                break;
        }
    });

    return requestBody.length > 0 ? requestBody : null;
}
